import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import newLogo from "../../../assets/icons/new-logo.png";
import styles from "./style.module.scss";
import { DashboardRouteUtil } from "../../../core/routes/dashboard.route";
import { SidebarType } from "../../../core/types/sidebar.type";
import { Can } from "../../../components/can";
import { useEffect, useState } from "react";
import React from "react";

export type DashboardWrapperProps = {
  children: JSX.Element;
  withoutHeader?: boolean;
  withOverlay?: boolean;
  fullOverlay?: boolean;
  title?: string;
  additionalMenu?: JSX.Element;
};

export const AppWrapper = ({ children }: DashboardWrapperProps) => {
  const { t } = useTranslation();
  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    if (pathArray[2]) {
      setActivePage(pathArray[2]);
    } else {
      setActivePage(pathArray[1]);
    }
  }, []);

  const list: SidebarType[] = [
    {
      lable: "dashboard",
      link: DashboardRouteUtil.getDashboardPath(),
      icon: require(`../../../assets/icons/dashboard.svg`).default,
      isActive: activePage === "dashboard",
      module: "dashboard",
    },
    {
      lable: "sellers",
      link: DashboardRouteUtil.getSellersListPath(),
      icon: require(`../../../assets/icons/sellers.svg`).default,
      isActive: activePage === "sellers",
      module: "sellers",
    },
    {
      lable: "customers",
      link: DashboardRouteUtil.getListCustomersPath(),
      icon: require(`../../../assets/icons/customers.svg`).default,
      isActive: activePage === "customers",
      module: "customers",
    },
    {
      lable: "audits",
      link: DashboardRouteUtil.getListAuditsPath(),
      icon: require(`../../../assets/icons/report.svg`).default,
      isActive: activePage === "audits",
      module: "audits",
    },
    {
      lable: "customers.feedback",
      link: DashboardRouteUtil.getListCustomersFeedbackPath(),
      icon: require(`../../../assets/icons/customers.svg`).default,
      isActive: activePage === "customers-feedback",
      module: "customers/feedbacks",
    },
    {
      lable: "orders",
      link: DashboardRouteUtil.getOrdersListPath(),
      icon: require(`../../../assets/icons/orders.svg`).default,
      isActive: activePage === "orders",
      module: "orders",
    },
    {
      lable: "catalog",
      link: DashboardRouteUtil.getCategoriesPath(),
      icon: require(`../../../assets/icons/catalog.svg`).default,
      isActive: activePage === "categories",
      module: "categories",
    },
    {
      lable: "subscription",
      link: DashboardRouteUtil.getSubscriptionsListPath(),
      icon: require(`../../../assets/icons/date.svg`).default,
      isActive: activePage === "subscriptions",
      module: "subscriptions",
    },
    {
      lable: "citiesManagement",
      link: DashboardRouteUtil.getCitiesListPath(),
      icon: require(`../../../assets/icons/cities.svg`).default,
      isActive: activePage === "location-management",
      module: "cities",
    },
    {
      lable: "seller.balance",
      link: DashboardRouteUtil.getSellerBalancePath(),
      icon: require(`../../../assets/icons/invoices.svg`).default,
      isActive: activePage === "seller-balance",
      module: 'navbar/sellerBalance',
    },
    {
      lable: "marketing",
      link: DashboardRouteUtil.getMarketingModulePath(),
      icon: require(`../../../assets/icons/offers.svg`).default,
      isActive: activePage === "marketing",
      module: "coupons",
    },
    {
      lable: "permissions",
      link: DashboardRouteUtil.getPermissionsModulePath(),
      icon: require(`../../../assets/icons/permissions.svg`).default,
      isActive: activePage === "permissions",
      module: "admins",
    },
    {
      lable: "setting",
      link: DashboardRouteUtil.getSubscriptionsSettingsListPath(),
      icon: require(`../../../assets/icons/cms.svg`).default,
      isActive: activePage === "settings",

      module: "subscription/durations",
    },
    {
      lable: "announcements",
      link: DashboardRouteUtil.getAnnouncementPath(),
      icon: require(`../../../assets/icons/announcement.svg`).default,
      isActive: activePage === "announcements",
      module: "announcements",
    },
    {
      lable: "banners",
      link: DashboardRouteUtil.getBannerPath(),
      icon: require(`../../../assets/icons/announcement.svg`).default,
      isActive: activePage === "banners",
      module: "home/banner",
    },
    {
      lable: "notifications",
      link: DashboardRouteUtil.getNotificationPath(),
      icon: require(`../../../assets/icons/push-notification.svg`).default,
      isActive: activePage === "notifications",
      module: "portal/notifications",
    },
    {
      lable: "payment-transaction",
      link: DashboardRouteUtil.getPaymentTransaction(),
      icon: require(`../../../assets/icons/transaction.svg`).default,
      isActive: activePage === "payment-transaction",
      module: "payment/transactions",
    },
    {
      lable: "reports.coupon",
      link: DashboardRouteUtil.getReportsCoupon(),
      icon: require(`../../../assets/icons/report.svg`).default,
      isActive: activePage === "reports/coupon",
      module: "coupon/reports",
    },
  ];

  return (
    <>
      <Container className="d-block">
        <div className={"overlay-container"} />
      </Container>
      <div className={`${styles.wrapper} d-md-flex`}>
        <div className={`d-sm-block app-side-menu ${styles.sideBar}`}>
          <Container>
            <Row className="align-items-center justify-content-center">
              <Col className="m-2 text-center">
                <img src={newLogo} alt="Mazaj" width={100} className="large-mazaj-logo" />
                <img
                  src={newLogo}
                  alt="Mazaj"
                  width="48"
                  height="20"
                  className="small-mazaj-logo"
                />
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              {list.map((item: SidebarType) => (
                <Can do={"view"} on={item?.module} key={`app-route-${item.link}`}>
                  <Col xs="12">
                    <Link to={item.link} className="text-decoration-none" onClick={() => window.location.href = `${item.link}`}>
                      <Button
                        className={`${styles.btnFont} ${item.isActive ? "text-primary bg-primary-light" : ""
                          } w-100 py-2 d-flex align-items-center btn-primary-light mb-3`}
                        variant=""
                      >
                        <img src={item.icon} alt={item.lable} />
                        <span className="mx-3 menu-item-label">
                          {t(`wrappers.dashboard.${item.lable}`)}
                        </span>
                      </Button>
                    </Link>
                  </Col>
                </Can>
              ))}
            </Row>
            <div className={"overlay-container"} />
          </Container>
        </div>
        {children}
      </div>
    </>
  );
};
